export function convertQuillToInlineStyles(html: string): string {
  if (!html) return "";
  html = html.replace(/class="ql-align-center"/g, 'style="text-align:center;"');
  html = html.replace(/class="ql-align-right"/g, 'style="text-align:right;"');
  html = html.replace(/class="ql-align-left"/g, 'style="text-align:left;"');

  html = html.replace(
    /<ul class="ql-bullet">/g,
    '<ul style="list-style-type:disc; padding-left:1.2em;">'
  );
  html = html.replace(
    /<ol class="ql-ordered">/g,
    '<ol style="list-style-type:decimal; padding-left:1.2em;">'
  );

  html = html.replace(/class="ql-color-([^"]+)"/g, (_, color) => `style="color:${color};"`);
  html = html.replace(
    /class="ql-background-([^"]+)"/g,
    (_, bg) => `style="background-color:${bg};"`
  );
  return html;
}
